import React, { createContext, useState, useEffect } from "react";
import Data from "../componentes/Data2.js";
import { Toaster, toast } from 'react-hot-toast';

export const DataContext = createContext();


export const DataProvider = (props) => {
	const [productos, setProductos] = useState([]);
	const [menu, setMenu] = useState(false)
	const [carrito, setCarrito] = useState([])
	const [total, setTotal] = useState(0)
	const notify = () => toast('Here is your toast.');

	console.log(carrito)

	useEffect(() => {
		const producto = Data.items
		if (producto) {
			setProductos(producto)
		} else {
			setProductos([])
		}
	}, []);

	const addCarrito = (id) => {
		<Toaster
			position="top-right"
			reverseOrder={false}
		/>
		const check = carrito.every(item => {
			return item.id !== id

		})
		if (check) {
			const data = productos.filter(producto => {
				return producto.id === id
			})
			setCarrito([...carrito, ...data])
			toast('Añadido con exito!',
  {
    icon: '✅',
    style: {
      borderRadius: '10px',
      background: '#333',
      color: '#fff',
    },
	position: "top-right"
  }
);
		} else {
			toast('En el carrito!',
  {
    icon: '👍',
    style: {
      borderRadius: '10px',
      background: '#333',
      color: '#fff',
    },
	position: "top-right"
	
  },
  
);


		}
	}
	useEffect(() => {
		const dataCarrito = JSON.parse(localStorage.getItem('dataCarrito'))
		if (dataCarrito) {
			setCarrito(dataCarrito)
		}
	}, [])

	useEffect(() => {
		localStorage.setItem('dataCarrito', JSON.stringify(carrito))
	}, [carrito])

	useEffect(() => {
		const getTotal = () => {
			const res = carrito.reduce((prev, item) => {
				return prev + (item.price * item.cantidad)
			}, 0)
			setTotal(res)
		}
		getTotal()
	}, [carrito])

	const value = {
		productos: [productos],
		menu: [menu, setMenu],
		carrito: [carrito, setCarrito],
		addCarrito: addCarrito,
		total: [total, setTotal]
	}
	return (
		<DataContext.Provider value={value}>
			{props.children}
		</DataContext.Provider>
	)
};
